<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <rx-modal-content (closeModal)="activeModal.dismiss()">
    <h3 class="modal-title">{{ t('heading') }}</h3>
    <div class="modal-body">
      <div class="mb-3">{{ t('notification') }}</div>
    </div>
    <div class="d-flex justify-content-end modal-footer">
      <rx-button
        buttonClass="subtle"
        class="mr-2"
        (click)="activeModal.dismiss()"
        [attr.data-qa]="'test-out-of-office-delete-cancel-button'"
        >{{ t('cancel') }}</rx-button
      >
      <rx-button
        buttonClass="primary red"
        (click)="confirmDeletion()"
        [attr.data-qa]="'test-out-of-office-delete-confirmation-button'"
        >{{ t('delete') }}</rx-button
      >
    </div>
  </rx-modal-content>
</ng-container>
